import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, Observable, of, switchMap, tap } from 'rxjs';

import { CompanyActions, CompanyApiActions, selectCompanyUuid, selectWebShopUrl } from '@public-page/store/company';
import { GlobalService } from '@modules/core/services';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CompanyPublicApiService, GetCompanyPublicInfoResponseDTOV2 } from '@paymash/sdk/api';
import { CompanyMapper } from '@modules/core/mappers';

@Injectable()
export class CompanyEffects {
  constructor(
    private actions$: Actions,
    private companyApiService: CompanyPublicApiService,
    private globalService: GlobalService,
    private router: Router,
    private store: Store,
    private companyMapper: CompanyMapper
  ) {}
  /* eslint-disable @typescript-eslint/no-unused-vars */

  loadCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.load),
      switchMap((): Observable<GetCompanyPublicInfoResponseDTOV2> => {
        if (this.globalService.hasCustomDomain) {
          const domain: string = this.globalService.customDomain;
          return this.companyApiService.getCompanyByDomain({ domain });
        }
        const companyUuid: string = this.globalService.companyUuid;
        return this.companyApiService.getCompanyByUuid({ companyUuid });
      }),
      map((company) => CompanyApiActions.loadedSuccess({ company: this.companyMapper.mapToEntity(company) })),
      catchError(() => of(CompanyApiActions.loadedFailure()))
    );
  });

  redirectToCompanyPage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CompanyActions.redirectToCompanyPage),
        concatLatestFrom(() => this.store.select(selectCompanyUuid)),
        tap(([action, companyUuid]) => {
          const path = this.globalService.hasCustomDomain ? ['public'] : [companyUuid, 'public'];

          this.router.navigate(path, {
            replaceUrl: true,
          });
        })
      );
    },
    { dispatch: false }
  );

  redirectToOnlineShop$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CompanyActions.redirectToOnlineShop),
        concatLatestFrom(() => this.store.select(selectWebShopUrl)),
        tap(([action, webShopUrl]) => {
          if (webShopUrl) {
            window.location.href = webShopUrl;
          }
        })
      );
    },
    { dispatch: false }
  );
}
